export default "__VITE_ASSET__PdrK1kDD__"